const labels = {
  All: { 'See the offering': "Voir l'offre" },
  FacilityDetails: { 'Ref: Page title': "Détails de l'installation", 'Ref: Review': 'Avis' },
  FacilitiesList: { 'Ref: Page title': 'Installations', 'Ref: See details': 'Voir les détails' },
};
export default labels;
